<div class="main-wrapper mx-auto" >
	<main class="main d-flex align-items-center">
		<div class="container">
			<div class="row">
				<div class="col-12 col-md-10 col-lg-8 mx-md-auto p-sm-0 mx-lg-auto">
					<div class="card mx-4" >
						<div class="card-header">
							<div class="row">
								<div class="col-8">
									<h4 class="">Change Password</h4>
								</div>
								<div class="col-4 ">
									<button (click)="back()" class="btn  btn-light text-dark float-right"><i
											class="fa fa-reply"></i>&nbsp;<b>Back</b></button>
								</div>
							</div>
						</div>
						<div class="card-body">
							<form [formGroup]="changePasswordForm">
								<div class="row ">
									<div class="col-md-6 col-lg-12 col-sm-6">
										<div class="form-group ">
											<label class="fw-bold">Old Password<span class="required">*</span></label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text"><i class="fa fa-lock"
															aria-hidden="true"></i></span>
												</div>
												<input class="form-control" type="text" formControlName="oldPassword"
													name="password">
											</div>
											<div class="error-msg-area">
												<div *ngIf="changePasswordForm.controls['oldPassword'].errors && (!changePasswordForm.controls['oldPassword'].pristine|| ischangePasswordFormSubmitted)"
													class="error-msg">
													<div
														[hidden]="!changePasswordForm.controls['oldPassword'].errors.required">
														Please Enter Old Password
													</div>
												</div>
											</div>
										</div>

									</div>
									<div class="col-md-6 col-lg-12 col-sm-6">
										<div class="form-group ">
											<label class="fw-bold">New Password<span class="required">*</span></label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text"><i class="fa fa-lock"
															aria-hidden="true"></i></span>
												</div>
												<input class="form-control" type="text" formControlName="newPassword"
													name="password">
											</div>
											<div class="error-msg-area">
												<div *ngIf="changePasswordForm.controls['newPassword'].errors && (!changePasswordForm.controls['newPassword'].pristine|| ischangePasswordFormSubmitted)"
													class="error-msg">
													<div
														[hidden]="!changePasswordForm.controls['newPassword'].errors.required">
														Please Enter New Password
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</form>
							<!-- <div class="card-footer"> -->

								<button type="submit" class="btn btn-primary" style="margin-top:20px;" [disabled]="spinner" (click)="onSubmit()">Submit</button>
							<!-- </div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</main>
</div>
<div class="loader" *ngIf="spinner"></div>